import { attr } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  html: validator('presence', true),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class HtmlModel extends Model.extend(Validations) {
  @attr('string') html;
}
